{
  "version": 1,
  "asset_id": "ade2727b-ac06-40a2-8d7f-5e9882b6d042",
  "project_id": "1203040e-940d-4f2e-ab5b-8733ed2d3c31",
  "url": "/__l5e/assets-v1/ade2727b-ac06-40a2-8d7f-5e9882b6d042/opt_assistido-3.jpg",
  "r2_key": "a/v1/1203040e-940d-4f2e-ab5b-8733ed2d3c31/ade2727b-ac06-40a2-8d7f-5e9882b6d042/opt_assistido-3.jpg",
  "original_filename": "opt_assistido-3.jpg",
  "size": 91949,
  "content_type": "image/jpeg",
  "created_at": "2026-08-26T20:32:58Z"
}
